@if (icon) {
  <span class="icon {{ align ? 'icon--' + align : '' }} icon--color-{{ color }}">
    <mat-icon class="icon__main" [svgIcon]="icon" [ngClass]="{ 'icon__main--width-auto': !width, 'icon__main--height-auto': !height, 'icon__main--fit': fit }" [ngStyle]="{ 'width.px': width, 'height.px': height, transform: rotate ? 'rotate(' + rotate + 'deg)' : '' }"></mat-icon>
    <span class="icon__text">
      <ng-content></ng-content>
    </span>
  </span>
}
